import { render, staticRenderFns } from "./bg-image.vue?vue&type=template&id=534da4ee&scoped=true&"
import script from "./bg-image.vue?vue&type=script&lang=ts&"
export * from "./bg-image.vue?vue&type=script&lang=ts&"
import style0 from "./bg-image.vue?vue&type=style&index=0&id=534da4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534da4ee",
  null
  
)

export default component.exports